const ROUTER_API_KEY_STORAGE_PREFIX = 'promptlab.routerApiKey';

const buildRouterApiKeyStorageKey = (projectId: string) =>
  `${ROUTER_API_KEY_STORAGE_PREFIX}.${projectId}`;

export const getRouterApiKey = (projectId?: string | null): string | null => {
  if (typeof window === 'undefined' || !projectId) return null;
  return window.localStorage.getItem(buildRouterApiKeyStorageKey(projectId));
};

export const setRouterApiKey = (projectId: string, token: string | null) => {
  if (typeof window === 'undefined' || !projectId) return;
  const storageKey = buildRouterApiKeyStorageKey(projectId);
  if (!token) {
    window.localStorage.removeItem(storageKey);
    return;
  }
  window.localStorage.setItem(storageKey, token);
};
